import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { findCometScript, installCometLinkDecorator, isCometPixelLocation } from "src/utils/cometToken";

const COMET_PIXEL_SRC =
  "https://m.inhouse.ai/script.js?uid=19c526-1125899910000000-b18b59-s&domains=www.inhouse.ai,platform.inhouse.ai";

function ensureCometPixel() {
  if (findCometScript()) return;

  const script = document.createElement("script");
  script.src = COMET_PIXEL_SRC;
  script.setAttribute("data-ctag", "cmt");
  script.addEventListener(
    "load",
    () => {
      if (!isCometPixelLocation(window.location.pathname, window.location.search)) {
        window.cometPauseEvents?.();
      }
    },
    { once: true }
  );
  document.head.appendChild(script);
}

export default function CometPixel() {
  const { pathname, search } = useLocation();
  const active = isCometPixelLocation(pathname, search);

  // Runs on every page: the pixel is paused on most of them and does not add
  // the token to links itself.
  useEffect(() => installCometLinkDecorator(), []);

  useEffect(() => {
    if (process.env.REACT_APP_FRONTEND_BASE_ENDPOINT !== "https://platform.inhouse.ai") {
      return;
    }

    if (!active) {
      window.cometPauseEvents?.();
      return;
    }

    ensureCometPixel();
    window.cometResumeEvents?.();

    return () => {
      window.cometPauseEvents?.();
    };
  }, [active]);

  return null;
}
